import { render, staticRenderFns } from "./rebateDealList.vue?vue&type=template&id=2c4c7b56"
import script from "./rebateDealList.vue?vue&type=script&lang=js"
export * from "./rebateDealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports